import React, { useState, useEffect, useRef } from 'react';
import { View, StyleSheet, Dimensions, ScrollView, useWindowDimensions, useColorScheme, Platform } from "react-native";
import { showMessage } from "react-native-flash-message";
import { useTheme } from '@react-navigation/native';
import CustomButton from '../../../components/CustomButton';
import { ActivityIndicator } from 'react-native-paper';
import { useSignin } from '../../../hooks/useSignIn';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { useMsal } from '@azure/msal-react';
import { loginRequest, msalInstance } from '../../../../authConfig';

const window = Dimensions.get("window");
// * Logo Path
import { Light, Dark } from '../../../img/logos';

// * Language 
import { useTranslation } from 'react-i18next';

const SignInScreen2FA = ({ navigation, route }) => {

  const { t } = useTranslation();
  let colorScheme = useColorScheme();
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const submitClickedRef = useRef(null);
  const [submitClicked, setSubmitClicked] = useState(false);
  const { signIn2FA, isLoading } = useSignin();
  const { instance } = useMsal();

  useEffect(() => {
    submitClickedRef.current = submitClicked;
  }, [submitClicked]);

  const onSignInPressed = async (e) => {
    e.preventDefault();
    setSubmitClicked(true);
    //* If Client Api is set then show the Sign In screen otherwise show the sign up screen
    await AsyncStorage.getItem('client_api').then((response) => {
      if (response !== undefined && response !== null) {
        let rJson = JSON.parse(response)
        instance.loginPopup(loginRequest).then(response => {
          // console.log('resonse', response);
          signIn2FA(response, rJson.clientApi);
        }).catch(error => {
          console.error(error);
        });
      }
      else {
        console.error(t('common:apiNotExists'))
      }
    });

  };

  const outputErrorMessage = (message) => {
    showMessage({
      message: message,
      type: "danger",
      duration: 3000,
    });
  }

  return (
    <ScrollView
      style={styles.areaview}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
      <View style={styles.root}>
        <Light />
        <CustomButton
          text={t('common:signIn')}
          // disable while processing one request 
          disabled={isLoading}
          onPress={onSignInPressed}
          type="LOGIN"
          isGradient={true}
        />
        {/* <CustomText style={styles.copyright}>Oasys by Deloitte</CustomText> */}
        {isLoading &&
          <View style={styles.loading}>
            <ActivityIndicator animating={true} size='large' color="#86BC25" />
          </View>
        }
      </View>
    </ScrollView>
  );
};

const makeStyles = (colors) => StyleSheet.create({
  areaview: {
    backgroundColor: '00F0F8FF'
  },
  root: {
    flex: 1,
    alignItems: "center",
    justifyContent: 'center',
    width: Platform.OS === 'web' ? (window.width < 500 ? window.width : window.width * 0.2) : window.width * 0.9,
    padding: 20,
    backgroundColor: colors.background,
  },
  title_hidden: {
    paddingTop: '10%',
    paddingBottom: '10%',
  },
  title: {
    fontSize: 24,
    paddingTop: '20%',
    paddingBottom: '10%',
    fontWeight: 'bold',
    color: colors.text_input,
    margin: 10,
  },
  tinyLogo: {
    width: 152,
    height: 172,
  },
  error: {
    color: colors.validation_error,
    alignSelf: 'center',
    fontSize: 14,
  },
  copyright: {
    marginVertical: '10%',
    paddingBottom: '12%',
    fontSize: 13,
    color: '#6e6e6e',
  }
});

export default SignInScreen2FA;